module.exports = __webpack_public_path__ + "img/1791993204960.2ba9df2b.png";